import React from 'react';

import type {AdaptiveSubject} from '../AdaptiveSubjects.types';

import {AdaptiveSubjectCourseCard} from '../AdaptiveSubjectCourseCard/AdaptiveSubjectCourseCard';

interface AdaptiveSubjectsProps {
  subjects: AdaptiveSubject[];
  subjectCardClassName?: string;
  emptyState?: React.ReactNode;
  isLoggedOutOrStudent?: boolean;
}

export const AdaptiveSubjects = ({
  subjects,
  subjectCardClassName,
  emptyState,
  isLoggedOutOrStudent
}: AdaptiveSubjectsProps) => {
  if (!subjects.length) {
    return emptyState;
  }

  return (
    <div className='adaptive-subjects-library subject-cards-wrapper subject-cards-wrapper--course-library'>
      {subjects.map((subject) => (
        <AdaptiveSubjectCourseCard
          key={subject.id}
          subjectId={subject.id}
          subjectName={subject.name}
          subjectUrlSlug={subject.urlSlug}
          subjectDescription={subject.description || ''}
          curriculumAreaName={subject.curriculumArea?.name || ''}
          className={subjectCardClassName}
          isLoggedOutOrStudent={isLoggedOutOrStudent}
          data-testid={subject.name}
        />
      ))}
    </div>
  );
};
